import { ONE_PAGE_VIEW, VIEW_PDF } from 'constants/paths';

import { getVariable } from './environment.utils';
import { insertId } from './path';

const ROOT_PATH = getVariable('REACT_APP_ENV_ROOT_PATH');

export const getPDFViewLink = (id: string) => insertId(VIEW_PDF, id);

export const copyPdfLink = (id: string): Promise<void> =>
  navigator.clipboard.writeText(`${ROOT_PATH}${getPDFViewLink(id)}`);

export const copyOnePageLink = (id: string): Promise<void> =>
  navigator.clipboard.writeText(`${ROOT_PATH}${insertId(ONE_PAGE_VIEW, id)}`);

export const viewDocHandler = (id: string): Window | null => window.open(getPDFViewLink(id), '_blank');
